export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-progress/index.js